import { useState } from "react";
import { errorMessage, printFileHelper, saveFileHelper } from "../../../utils";
import { exportFtiPdfApi } from "../apis";


const generatedPdfs = new Map();


export const useFtiPdfExport = () => {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateFtiPdf = async (id) => {
    setIsGenerating(true);
    try {
      generatedPdfs.set(String(id), await exportFtiPdfApi(id));
      return true;
    } catch (error) {
      errorMessage("Failed to export the full tax invoice PDF");
      return false;
    } finally {
      setIsGenerating(false);
    }
  };

  const hasGeneratedPdf = (id) => generatedPdfs.has(String(id));

  // `action` is "download" to save the PDF or "print" to open the browser's print dialog
  const deliverGeneratedPdf = ({ id, fti_invoice_number }, action) => {
    const response = generatedPdfs.get(String(id));
    if (!response) return;
    generatedPdfs.delete(String(id));
    if (action === "print") {
      printFileHelper(response.data);
    } else {
      saveFileHelper({
        response,
        fileName: `FTI-${fti_invoice_number ?? id}.pdf`,
      });
    }
  };

  return {
    isGenerating,
    generateFtiPdf,
    hasGeneratedPdf,
    deliverGeneratedPdf,
  };
};
